import React, { FC } from 'react';
import { AlternativeItineraryDoubleCardLayerTopSectionDropdownProps } from '@components/AlternativeItineraryDoubleCard/components/AlternativeItineraryDoubleCardLayer/types';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { Box } from '@edreamsodigeo/prisma-design-system';
import AlternativeItineraryDoubleCardDropdownLayerTitle from '@components/AlternativeItineraryDoubleCard/components/AlternativeItineraryDoubleCardLayer/AlternativeItineraryDoubleCardDropdownLayerTitle';
import AlternativeItineraryDoubleCardLayerCard from '@components/AlternativeItineraryDoubleCard/components/AlternativeItineraryDoubleCardLayerCard/AlternativeItineraryDoubleCardLayerCard';

const AlternativeItineraryDoubleCardDropdownLayerTopSection: FC<
  AlternativeItineraryDoubleCardLayerTopSectionDropdownProps
> = ({
  itinerary,
  nonIssuable,
  isUnavailable = true,
  isTopSectionExpanded,
  onTitleClick,
  trackingHandler,
  onSelectOriginalItinerary,
  overrideAction,
}) => {
  const { t } = useTranslation();

  const titleContent = nonIssuable
    ? 'alternativeItinerary.nonIssuable.layer.unavailable.title'
    : 'alternativeItinerary.improvement.issuable.layer.title';
  const isClickable = !nonIssuable;
  return (
    <Box
      marginBottom={'big'}
      paddingX={'1x_big'}
      sx={{
        '*': {
          boxShadow: 'none !important',
        },
      }}
    >
      <AlternativeItineraryDoubleCardDropdownLayerTitle
        sx={{ marginBottom: '16px' }}
        isTopSectionExpanded={isTopSectionExpanded}
        onClick={onTitleClick}
      >
        {t(titleContent)}
      </AlternativeItineraryDoubleCardDropdownLayerTitle>

      <AlternativeItineraryDoubleCardLayerCard
        isAlternativeItineraryOnModal
        itinerary={itinerary}
        nonIssuable={nonIssuable}
        isClickable={isClickable}
        isAlternativeItinerary={false}
        isSelectedItinerary={true}
        hasAlternativeItineraryDecorator={false}
        isAlternativeTopSection={true}
        isUnavailable={nonIssuable && isUnavailable}
        trackingHandler={trackingHandler}
        onSelectOriginalItinerary={onSelectOriginalItinerary}
        overrideAction={overrideAction}
      />
    </Box>
  );
};

export default AlternativeItineraryDoubleCardDropdownLayerTopSection;
